import React, { useState, useEffect, useRef, useMemo } from 'react';
import DataTable from '../ui/DataTable';
import { StatusBadge, Chip } from '../ui/primitives';
import PageActionsMenu, {
  ActionsMenuItem,
  ActionsSection,
} from '../ui/PageActionsMenu';
import { getCache, setCache, clearCacheByPrefix } from '../ui/listCache';
import DeleteConfirmDialog from '../ui/DeleteConfirmDialog';
import NoticeDialog from '../ui/NoticeDialog';
import FormDialog from './dialog';
import { MdEditNote, MdDelete  } from "react-icons/md";
import { FiSettings } from "react-icons/fi";
import { Button } from '@mui/material';
import { Plus, Users, BarChart2, BookOpen } from 'lucide-react';
import QuestionsShowdialog from './showquestion';
import Assignstudentdialog from './assignstudentdialog';
import { useNavigate } from 'react-router-dom';
import AssessmentDialog from '../course/assessmentdialog';
import axios from 'axios';
import PackageDialog from '../course/packagedialog';
import styled from 'styled-components';
import GenerateQuestiondialog from './GenerateQuestiondialog';
import ReportDialog from "./ReportDialog";
import { useConfirm } from '../ui/ConfirmProvider';
import { useCourseFilter } from '../context/CourseFilterContext';
import { useAppContext } from '../../appprovider';
import {
  INSTRUCTOR_METERS,
  isMeterAtCap,
  meterGateBody,
  canUseAiCourseBuilder,
  aiCourseBuilderGateBody,
} from '../services/instructorMeterLimits';
import InstructorListStatsRow from '../ui/InstructorListStatsRow';
import AssessmentSettingDialog from './AssessmentSettingDialog';
import AssessmentRowActionsMenu from './AssessmentRowActionsMenu';
import { LabelWithHelp } from '../ui/FieldHelp';
import { LIST_TABLE_FIELD_HELP as TABLE_HELP } from '../ui/settingsFieldHelp';
import {
  buildAssessmentListQuery,
  buildAssessmentListCacheKey,
  parseAssessmentListResponse,
  ASSESSMENT_LIST_DEFAULTS,
  ASSESSMENT_SORT_FIELDS,
  getNextAssessmentSort,
  sortAssessmentsLocally,
} from './assessmentListApi';
import useDemoActionGate from '../hooks/useDemoActionGate';
import DemoLockedDialog from '../ui/DemoLockedDialog';

const ASSESSMENT_PAGE_SIZE = 10;

const PageShell = styled.div`

  min-height: calc(100vh - 32px);
  margin: 0 auto;
  padding: 0 28px 36px;
  color: ${({ theme }) => theme.text};
  font-family: ${({ theme }) => theme.fontBody};

  select {
    height: ${({ theme }) => theme.controlH};
    padding: 0 34px 0 12px;
    border: 1px solid ${({ theme }) => theme.border};
    border-radius: ${({ theme }) => theme.rMd};
    background: ${({ theme }) => theme.surface};
    color: ${({ theme }) => theme.text};
    font-size: ${({ theme }) => theme.fsSm};
    font-weight: 650;
    outline: none;
    box-shadow: 0 1px 2px rgba(17, 20, 38, 0.06);
  }

  @media (max-width: 768px) {
    padding: 0 14px 28px;
  }
`;

const PageHero = styled.div`
  width: min(1180px, 100%);
  margin: ${({ theme }) => theme.space} auto ${({ theme }) => theme.gap};
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  h2 {
    margin: 0;
    color: ${({ theme }) => theme.text};
    font-family: ${({ theme }) => theme.fontHead};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -.01em;
  }

  p {
    margin: 2px 0 0;
    color: ${({ theme }) => theme.textMuted};
    font-size: ${({ theme }) => theme.fsSm};
  }
`;

const TableWrap = styled.div`
  width: min(1180px, 100%);
  margin: 0 auto;
`;

const initialValue = { testId:"",courseName: "",courseId:"",name: "",vendor:"",type:"",total_marks:"", created_at: "", expires_in: "",enabled: "",price:"",purchase:"",domain:[],grade:"",exam_code:"" }
const Assignment = () => {
  const askConfirmation = useConfirm();
  const { openUpgradeGate, entitlements, entitlementsLoading } = useAppContext();
  const { isLocked, guardAction, lockProps, lockedDialogOpen, setLockedDialogOpen } = useDemoActionGate();
  const { selectedCourseId } = useCourseFilter();
  const userId = localStorage.getItem('userId');
  const [gridApi, setGridApi] = useState(null)
  const [tableData, setTableData] = useState(null)
  const [open, setOpen] = React.useState(false);
  const [formData, setFormData] = useState(initialValue)
  const [isQuestionShowDialogOpen, setQuestionShowDialogOpen] = useState(false);
  const [isAssignStudentDialogOpen, setAssignStudentDialogOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertTitle, setAlertTitle] = useState('');
  const [rowCount, setRowCount] = useState(0);
  const [assessmentPage, setAssessmentPage] = useState(0);
  const [assessmentTotalPages, setAssessmentTotalPages] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [debouncedKeyword, setDebouncedKeyword] = useState('');
  const [assessmentSortBy, setAssessmentSortBy] = useState(ASSESSMENT_LIST_DEFAULTS.sortBy);
  const [assessmentSortDir, setAssessmentSortDir] = useState(ASSESSMENT_LIST_DEFAULTS.sortDir);
  const searchDebounceRef = useRef(null);
  const [isPackageDialogOpen, setPackageDialogOpen] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [isAssessmentDialogOpen, setAssessmentDialogOpen] = useState(false);
  const [isGenerateQuestionDialogOpen, setGenerateQuestionDialogOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [settingsAssessment, setSettingsAssessment] = useState(null);
   const navigate = useNavigate();
   const userType = localStorage.getItem("userType");
   const [columnDefs, setColumnDefs] = useState([]);
   const [reportDialogOpen, setReportDialogOpen] = useState(false);
   const [reportData, setReportData] = useState(null);
   const [loading, setLoading] = useState(false);
   const [reportLoading, setReportLoading] = useState(false);
      const [isMobile,setIsMobile] = useState(false)
    useEffect(() => {
      const planExpire = localStorage.getItem('planExpire');
  
      if (planExpire === "1" && userType!=2) {
        sessionStorage.removeItem('planRenewDismissed');
        navigate('/Portal/Instructor');
      }
    }, [navigate]);

  const handleShowAlert = (message, title = 'Notice') => {
    setAlertTitle(title);
    setAlertMessage(message);
    setShowAlert(true);
  };

  const showSelectAssessmentNotice = () => {
    setAlertTitle('Please select an assessment');
    setAlertMessage('Choose exactly one assessment from the table, then try again.');
    setShowAlert(true);
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const handleOpenSettings = (row) => {
    if (!guardAction('action.assessment.settings')) return;
    const target = row || (selectedRows.length === 1 ? selectedRows[0] : null);
    if (!target) {
      showSelectAssessmentNotice();
      return;
    }
    setSettingsAssessment(target);
    setSettingsOpen(true);
  };

  const handleCloseSettings = () => {
    setSettingsOpen(false);
    setSettingsAssessment(null);
  };

  const getBasicAuthHeader = () => {
    const username = process.env.REACT_APP_API_USERNAME;
    const password = process.env.REACT_APP_API_PASSWORD;
    const encodedCredentials = btoa(`${username}:${password}`);
    return `Basic ${encodedCredentials}`;
  };

  const invalidateAssessmentListCache = () => {
    if (userId) clearCacheByPrefix(`assessments:${userId}:`);
  };

  const applyAssessmentListPage = (parsed) => {
    setTableData(parsed.content);
    setRowCount(parsed.totalElements);
    setAssessmentTotalPages(Math.max(parsed.totalPages, 1));
    setAssessmentPage(parsed.page);
  };

  useEffect(() => {
    if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => {
      setDebouncedKeyword(searchKeyword);
      setAssessmentPage(0);
    }, 300);
    return () => {
      if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    };
  }, [searchKeyword]);

  useEffect(() => {
    setAssessmentPage(0);
  }, [selectedCourseId]);

  useEffect(() => {
    if (userId) getUsers(assessmentPage, debouncedKeyword);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, assessmentPage, debouncedKeyword, selectedCourseId]);

  const sortedTableData = useMemo(
    () => sortAssessmentsLocally(tableData || [], assessmentSortBy, assessmentSortDir),
    [tableData, assessmentSortBy, assessmentSortDir],
  );

  const handleClickOpen = () => {
    setOpen(true);
  };
const rowSelection = 'multiple';

  const handleClose = () => {
    setOpen(false);
    setFormData(initialValue)
    invalidateAssessmentListCache();
    getUsers(assessmentPage, debouncedKeyword);
  };
  
  const formatDate = (timestampString) => {
    if (!timestampString) {
        return ''; // Return empty string if timestampString is null or undefined
    }

    const timestamp = new Date(parseInt(timestampString));

    // Check if the date is invalid
    if (isNaN(timestamp.getTime())) {
        return ''; // Return an empty string if the date is invalid
    }

    const day = timestamp.getDate().toString().padStart(2, '0');
    const month = timestamp.toLocaleString('en-US', { month: 'short' }).toUpperCase(); // Convert month to uppercase three-letter format
    const year = timestamp.getFullYear();

    return `${day}-${month}-${year}`;
};


const handleSelectionChanged = () => {
  const selectedNodes = gridApi.getSelectedNodes();
  const selectedData = selectedNodes.map(node => node.data);
  setSelectedRows(selectedData);
};

useEffect(() => {
  const updateColumns = () => {
    const isMobile = window.innerWidth < 768;
    setColumnDefs(getColumnDefs(isMobile));
    setIsMobile(isMobile)
  };

  updateColumns(); // initial
  window.addEventListener("resize", updateColumns);
  return () => window.removeEventListener("resize", updateColumns);
}, []);

const getColumnDefs = (isMobile) => [
    { headerName: "Assessment Name", field: "name", checkboxSelection: !isMobile,
      valueFormatter: (params) => {
        const { name, price } = params.data || {};
        return price ? `$ ${name}` : name;
      }
     },
    { headerName: "Course Name", field: "courseName", hide: isMobile },
    { headerName: "Start Date", field: "startDate", valueFormatter: params => formatDate(params.data['startDate']), hide: isMobile },
    { headerName: "End Date", field: "endDate", valueFormatter: params => formatDate(params.data['endDate']), hide: isMobile}, 
    { headerName: "Status", field: "active",
      cellRenderer: (params) => {
        return params.value === 1 ? 'Enable' : 'Disable';
    },
     },
    {
        headerName: "Actions", field: "id", width: 401, cellRenderer: (params) => (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              overflowX: "auto",
              overflowY: "hidden",
              maxWidth: "100%",
              alignItems: "center",
            }}
          >
              <Button
                                  variant="contained"
                                  color="primary"
                                  style={{
                                      backgroundColor: 'purple',
                                      color: 'white',
                                      width: '12px',
                                      height: '12px',
                                      marginBottom: '4px',
                                      fontSize: '8px',
                                      padding: '4px 10px',
                                  }}
                                  onClick={() => handleEnabled(params.data)}
                              >
                                  {params.data.active === 1 ? 'Disable' : 'Enable'}
                              </Button>
                <MdEditNote style={{ margin: "10px", "font-size": " 1.5em", color: "green", cursor: "pointer" }} onClick={() => {handleUpdate(params.data)}}>Update</MdEditNote>
                <FiSettings
                    style={{ margin: "10px", fontSize: "1.5em", color: "blue", cursor: "pointer" }}
                    title="Settings"
                    onClick={() => handleOpenSettings(params.data)}
                />
                <MdDelete style={{ margin: "10px", "font-size": " 1.5em", color: "purple", cursor: "pointer" }} onClick={() => handleDelete(params.data['testId'])}>Delete</MdDelete>
                
            </div>
        ),
    },
];

const handleEnabled = async (data) => {
  if (!guardAction('action.assessment.disable')) return;
  const action = data.active === 1 ? 'disable' : 'enable';
  const actionLabel = action.charAt(0).toUpperCase() + action.slice(1);
  const confirmed = await askConfirmation({
    title: `${actionLabel} assessment?`,
    message: `Are you sure you want to ${action} this assessment?`,
    confirmLabel: actionLabel,
  });
  if (!confirmed) return;

  try {
    const active = data.active === 1 ? 0 : 1;
    const body = {
      testId: data.testId,
      active,
    };
    await axios.put(apiUrl + '/api/update-assessment-active-status', body, {
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
        'Access-Control-Allow-Origin': '*',
        Authorization: getBasicAuthHeader(),
      },
    });
    invalidateAssessmentListCache();
    getUsers(assessmentPage, debouncedKeyword);
  } catch (err) {
    console.log(err.response ? err.response.data : 'Error');
  }
};

const handleShowQuestions = (testId) => {
  setSelectedTestId(testId);
  setQuestionShowDialogOpen(true);
};

const handleOpenAssignStudent = () => {
  setAssignStudentDialogOpen(true);
};

const focusAssessmentRow = (row) => {
  setSelectedRows([row]);
};

const assessmentRowShort = (r) => {
  if (r.price) return '$*';
  const parts = String(r.name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return (parts[0]?.slice(0, 2) || '?').toUpperCase();
};

const handleReviewForRow = (row) => {
  focusAssessmentRow(row);
  navigate('/Portal/Instructor/Questions', { state: { testId: row.testId } });
};

const handleGenerateForRow = (row) => {
  if (!canUseAiCourseBuilder(entitlements)) {
    openUpgradeGate(aiCourseBuilderGateBody(entitlements));
    return;
  }
  focusAssessmentRow(row);
  setGenerateQuestionDialogOpen(true);
};

const handleAssignForRow = (row) => {
  focusAssessmentRow(row);
  if (isMeterAtCap(entitlements, INSTRUCTOR_METERS.students)) {
    openUpgradeGate(meterGateBody(INSTRUCTOR_METERS.students, entitlements));
    return;
  }
  handleOpenAssignStudent();
};

const handleDeleteForRow = (row) => {
  if (!guardAction('action.assessment.delete')) return;
  focusAssessmentRow(row);
  handleDelete(row.testId);
};

const handleResourceForRow = (row) => {
  if (!guardAction('action.assessment.resource')) return;
  focusAssessmentRow(row);
  handleReport(row);
};

const handleEditForRow = (row) => {
  if (!guardAction('action.assessment.edit')) return;
  focusAssessmentRow(row);
  handleUpdate(row);
};


  async function getUsers(page = 0, keyword = '') {
    const listParams = {
      page,
      size: ASSESSMENT_PAGE_SIZE,
      keyword,
      courseId: selectedCourseId,
    };
    const cacheKey = buildAssessmentListCacheKey(userId, listParams);
    const cached = getCache(cacheKey);
    if (cached) {
      applyAssessmentListPage(cached);
      setLoading(false);
      return;
    }

    setLoading(true);
    const query = buildAssessmentListQuery(listParams);
    try {
      const response = await axios.get(`${apiUrl}/api/Assessment/${userId}?${query}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
          'Access-Control-Allow-Origin': '*',
          Authorization: getBasicAuthHeader(),
        },
      });
      const parsed = parseAssessmentListResponse(response.data);
      applyAssessmentListPage(parsed);
      setCache(cacheKey, parsed);
    } catch (error) {
      console.error('Error fetching assessment data:', error);
    } finally {
      setLoading(false);
    }
  }

  const handleAssessmentPageChange = (nextPage) => {
    const zeroBasedPage = Math.max(nextPage - 1, 0);
    setAssessmentPage(zeroBasedPage);
  };

  const handleAssessmentSortChange = (columnKey) => {
    const next = getNextAssessmentSort(columnKey, assessmentSortBy, assessmentSortDir);
    setAssessmentSortBy(next.sortBy);
    setAssessmentSortDir(next.sortDir);
  };

  // Bulk delete selected assessments. Endpoint + body for the API team:
  //   POST {API}/api/Assessment/bulkDelete   body: { userId, testIds: [<testId>, ...] }
  // Typed delete confirmation shared by single + bulk delete.
  const [confirmState, setConfirmState] = useState({ open: false, count: 1, action: null });
  const askConfirm = (count, action) => setConfirmState({ open: true, count, action });
  const closeConfirm = () => setConfirmState({ open: false, count: 1, action: null });
  const runConfirm = async () => {
    const action = confirmState.action;
    closeConfirm();
    if (action) await action();
  };

  const handleBulkDelete = () => {
    if (!selectedRows.length) return;
    if (!guardAction('action.assessment.bulkDelete')) return;
    askConfirm(selectedRows.length, doBulkDelete);
  };

  const doBulkDelete = async () => {
    if (!selectedRows.length) return;
    const apiUrl = process.env.REACT_APP_API_URL;
    const bulkUserId = localStorage.getItem('userId');
    const testIds = selectedRows.map((r) => r.testId);
    try {
      await axios.post(`${apiUrl}/api/Assessment/bulkDelete`, { userId: bulkUserId, testIds }, {
        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
          'Access-Control-Allow-Origin': '*',
          Authorization: getBasicAuthHeader(),
        },
      });
      setSelectedRows([]);
      invalidateAssessmentListCache();
      getUsers(assessmentPage, debouncedKeyword);
    } catch (error) {
      console.error('Bulk delete failed:', error);
      setAlertTitle('Unable to delete assessments');
      setAlertMessage('Failed to delete the selected assessments. Please try again.');
      setShowAlert(true);
    }
  };
  const onChange = (e) => {
    const { value, id } = e.target
    // console.log(value,id)
    setFormData({ ...formData, [id]: value })
  }
  const [selectedTestId, setSelectedTestId] = useState(null);
  // setting update row data to form data and opening pop up window
  const handleUpdate = (oldData) => {
    if (!guardAction('action.assessment.edit')) return;
    setFormData(oldData)
    setSelectedTestId(oldData['testId']);
    handleClickOpen()
  }
  
  //deleting a user
  const handleDelete = (id) => {
    if (!guardAction('action.assessment.delete')) return;
    askConfirm(1, () => doDelete(id));
  };

  const doDelete = (id) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    {

      fetch(apiUrl + `/api/Assessment/deleteTest/${id}`, {
        method: "POST",
        headers: {
        'Content-Type': "application/json",
            "Accept": "*/*",
            "Access-Control-Allow-Origin": "*",
            'Authorization': getBasicAuthHeader(),
        }
      })
      .then(resp => resp.json())
      .then(() => { invalidateAssessmentListCache(); getUsers(assessmentPage, debouncedKeyword); });
    }
  }

  const handleFormSubmit = () => {
          invalidateAssessmentListCache()
          handleClose()
    }

  const handleAdd = () => {
    if (!guardAction('action.assessment.create')) return;
    if (isMeterAtCap(entitlements, INSTRUCTOR_METERS.assessments)) {
      openUpgradeGate(meterGateBody(INSTRUCTOR_METERS.assessments, entitlements));
      return;
    }
    setFormData(initialValue);
    setAssessmentDialogOpen(true);
  };

  const handleReport = async (row) => {
  const selectedAssessment = row || (selectedRows.length === 1 ? selectedRows[0] : null);
  if (!selectedAssessment) {
    showSelectAssessmentNotice();
    return;
  }

  setReportLoading(true);
  try {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await axios.get(
      `${apiUrl}/api/report-per-test/${selectedAssessment.testId}`,{
        headers: {
        'Content-Type': "application/json",
            "Accept": "*/*",
            "Access-Control-Allow-Origin": "*",
            'Authorization': getBasicAuthHeader(),
        }}
    );
    setReportData(response.data);
    setReportDialogOpen(true);
  } catch (error) {
    //console.error("Error fetching report:", error);
    setShowAlert(true);
  } finally {
    setReportLoading(false);
  }
};

  return (
    <PageShell>
      <PageHero>
        <div>
          <h2>Assessments</h2>
          <p>Create, review, assign students, and manage settings.</p>
        </div>
        <PageActionsMenu
          primaryLabel="New assessment"
          primaryIcon={<Plus size={16} strokeWidth={2.25} aria-hidden="true" />}
          onPrimaryClick={handleAdd}
          primaryLocked={isLocked('action.assessment.create')}
          menuTitle="Assessment tools"
          menuSubtitle="Related workflows across courses, learners, and scores."
        >
          {(closeActions) => (
            <>
              <ActionsSection label="People & scores">
                <ActionsMenuItem
                  label="Manage enrollments"
                  description="Add learners and assign course access"
                  icon={<Users size={15} strokeWidth={1.9} />}
                  closeActions={closeActions}
                  onClick={() => navigate('/Portal/Instructor/addEnrollee')}
                  {...lockProps('action.assessment.nav.enrollments')}
                />
                <ActionsMenuItem
                  label="Open grade center"
                  description="View scores and submission results"
                  icon={<BarChart2 size={15} strokeWidth={1.9} />}
                  closeActions={closeActions}
                  onClick={() => navigate('/Portal/Instructor/score')}
                  {...lockProps('action.assessment.nav.scores')}
                />
              </ActionsSection>
              <ActionsSection label="Courses">
                <ActionsMenuItem
                  label="Browse courses"
                  description="Open course list and materials"
                  icon={<BookOpen size={15} strokeWidth={1.9} />}
                  closeActions={closeActions}
                  onClick={() => navigate('/Portal/Instructor/Course')}
                  {...lockProps('action.assessment.nav.courses')}
                />
              </ActionsSection>
            </>
          )}
        </PageActionsMenu>
      </PageHero>
      <NoticeDialog
        open={showAlert}
        title={alertTitle}
        message={alertMessage}
        onClose={handleCloseAlert}
      />
    <TableWrap>
        <InstructorListStatsRow
          variant="assessments"
          entitlements={entitlements}
          entitlementsLoading={entitlementsLoading}
          rowCount={rowCount}
          rows={sortedTableData}
          loading={loading}
          totalPages={assessmentTotalPages}
        />
        <DataTable
          rows={sortedTableData}
          loading={loading}
          rowKey={(r, i) => r.testId ?? r.id ?? i}
          selectable
          pageSize={ASSESSMENT_PAGE_SIZE}
          serverSide
          page={assessmentPage + 1}
          totalPages={assessmentTotalPages}
          totalElements={rowCount}
          onPageChange={handleAssessmentPageChange}
          sortBy={assessmentSortBy}
          sortDir={assessmentSortDir}
          onSortChange={handleAssessmentSortChange}
          searchValue={searchKeyword}
          onSearchChange={setSearchKeyword}
          onSelectionChange={setSelectedRows}
          onRowClick={(r) => navigate('/Portal/Instructor/AssessmentDetail', { state: { assessment: r } })}
          bulkActions={(
            <Chip
              $soft
              style={{
                cursor: isLocked('action.assessment.bulkDelete') ? 'not-allowed' : 'pointer',
                color: '#d6455d',
                opacity: isLocked('action.assessment.bulkDelete') ? 0.55 : 1,
              }}
              onClick={handleBulkDelete}
            >
              Delete selected
            </Chip>
          )}
          search
          searchPlaceholder="Search assessments, courses…"
          filters={[
            { key: 'all', label: 'All', test: () => true },
            { key: 'enabled', label: 'Enabled', test: (r) => r.active === 1 },
            { key: 'disabled', label: 'Disabled', test: (r) => r.active !== 1 },
          ]}
          primary={{
            header: 'Assessment',
            sortKey: ASSESSMENT_SORT_FIELDS.name,
            label: (r) => (r.price ? `$ ${r.name}` : r.name),
            sub: (r) => r.courseName,
            short: assessmentRowShort,
          }}
          columns={[
            { header: 'Course', sortKey: ASSESSMENT_SORT_FIELDS.courseName, render: (r) => r.courseName, muted: true },
            { header: 'Start Date', sortKey: ASSESSMENT_SORT_FIELDS.startDate, render: (r) => formatDate(r.startDate), muted: true, mono: true },
            { header: 'End Date', sortKey: ASSESSMENT_SORT_FIELDS.endDate, render: (r) => formatDate(r.endDate), muted: true, mono: true },
            {
              header: <LabelWithHelp help={TABLE_HELP.assessmentStatus}>Status</LabelWithHelp>,
              sortKey: ASSESSMENT_SORT_FIELDS.active,
              render: (r) => (
                <StatusBadge
                  $active={r.active === 1}
                  style={{ cursor: 'pointer' }}
                  title={r.active === 1 ? 'Disable' : 'Enable'}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEnabled(r);
                  }}
                >
                  {r.active === 1 ? 'Enabled' : 'Disabled'}
                </StatusBadge>
              ),
            },
          ]}
          actionsColumnWidth={52}
          actions={(r) => (
            <AssessmentRowActionsMenu
              row={r}
              reportLoading={reportLoading}
              onReview={handleReviewForRow}
              onSettings={handleOpenSettings}
              onDelete={handleDeleteForRow}
              onGenerate={handleGenerateForRow}
              showAiBuilder={canUseAiCourseBuilder(entitlements)}
              onAssign={handleAssignForRow}
              onResource={handleResourceForRow}
              onEdit={handleEditForRow}
            />
          )}
          emptyText="No assessments yet."
        />
      </TableWrap>
      <AssessmentDialog open={isAssessmentDialogOpen} onChange={onChange} handleClose={()=> setAssessmentDialogOpen(false)}/>
      <PackageDialog open={isPackageDialogOpen} handleClose={()=> setPackageDialogOpen(false)}/>
      <QuestionsShowdialog open={isQuestionShowDialogOpen} handleClose={() => setQuestionShowDialogOpen(false)} testId={selectedTestId} />
      <Assignstudentdialog open={isAssignStudentDialogOpen} handleClose={() => setAssignStudentDialogOpen(false)} data={selectedRows[0]} />
      <GenerateQuestiondialog open={isGenerateQuestionDialogOpen} handleClose={() => setGenerateQuestionDialogOpen(false)} data={selectedRows[0]} testId={selectedTestId}/>
      <FormDialog open={open} handleClose={handleClose}
        data={formData} onChange={onChange} handleFormSubmit={handleFormSubmit} testId={selectedTestId}/>
        <ReportDialog
  open={reportDialogOpen}
  onClose={() => setReportDialogOpen(false)}
  reportData={reportData}
/>
      <DeleteConfirmDialog
        open={confirmState.open}
        count={confirmState.count}
        onClose={closeConfirm}
        onConfirm={runConfirm}
      />
      <AssessmentSettingDialog
        open={settingsOpen}
        testDetails={settingsAssessment}
        onClose={handleCloseSettings}
        saveLocked={isLocked('action.assessment.settings')}
        onSaveBlocked={() => setLockedDialogOpen(true)}
        onSaved={() => {
          invalidateAssessmentListCache();
          getUsers(assessmentPage, debouncedKeyword);
          handleCloseSettings();
        }}
      />
      <DemoLockedDialog open={lockedDialogOpen} onClose={() => setLockedDialogOpen(false)} />
    </PageShell>
  );
}

export default Assignment;
